// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-editor {
  max-height: 95% !important;
}

#editor-container {
  height: 102px;
  overflow-y: auto;
}

.ql-toolbar {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.ql-container {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.ql-error-toolbar {
  border-top-color: red !important;
  border-right-color: red !important;
  border-left-color: red !important;
}

.ql-error-container {
  border-right-color: red !important;
  border-left-color: red !important;
  border-bottom-color: red !important;
}

.ql-error-placeholder {
  color: red !important;
}

.ql-container {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.ql-container p {
  font-size: 14px;
}

.ql-snow.ql-toolbar button svg {
  fill: #acacac;
}

.ql-snow.ql-toolbar button svg:hover {
  fill: #053747;
}

.ql-active svg {
  fill: #053747 !important;
}

.ql-picker-options {
  flex-direction: column;
  flex-wrap: wrap;
  width: 390px !important;
  height: auto !important;
  right: -182px;
  max-height: 200px;
  border: 1px #cdcdcd solid;
  border-radius: 4px;
  padding: 8px !important;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: flex !important;
}

.ql-picker-item {
  width: 30px !important;
  height: 30px !important;
  border: 1px solid #eeeeee !important;
  border-radius: 4px;
}

.ql-blank {
  font-size: 14px;
}

.ql-blank::before {
  font-style: normal !important;
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/atoms/quillEditor/style.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".ql-editor {\r\n  max-height: 95% !important;\r\n}\r\n\r\n#editor-container {\r\n  height: 102px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.ql-toolbar {\r\n  border-top-right-radius: 5px;\r\n  border-top-left-radius: 5px;\r\n}\r\n\r\n.ql-container {\r\n  border-bottom-right-radius: 5px;\r\n  border-bottom-left-radius: 5px;\r\n}\r\n\r\n.ql-error-toolbar {\r\n  border-top-color: red !important;\r\n  border-right-color: red !important;\r\n  border-left-color: red !important;\r\n}\r\n\r\n.ql-error-container {\r\n  border-right-color: red !important;\r\n  border-left-color: red !important;\r\n  border-bottom-color: red !important;\r\n}\r\n\r\n.ql-error-placeholder {\r\n  color: red !important;\r\n}\r\n\r\n.ql-container {\r\n  border-bottom-right-radius: 5px;\r\n  border-bottom-left-radius: 5px;\r\n}\r\n\r\n.ql-container p {\r\n  font-size: 14px;\r\n}\r\n\r\n.ql-snow.ql-toolbar button svg {\r\n  fill: #acacac;\r\n}\r\n\r\n.ql-snow.ql-toolbar button svg:hover {\r\n  fill: #053747;\r\n}\r\n\r\n.ql-active svg {\r\n  fill: #053747 !important;\r\n}\r\n\r\n.ql-picker-options {\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  width: 390px !important;\r\n  height: auto !important;\r\n  right: -182px;\r\n  max-height: 200px;\r\n  border: 1px #cdcdcd solid;\r\n  border-radius: 4px;\r\n  padding: 8px !important;\r\n}\r\n\r\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\r\n  display: flex !important;\r\n}\r\n\r\n.ql-picker-item {\r\n  width: 30px !important;\r\n  height: 30px !important;\r\n  border: 1px solid #eeeeee !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n.ql-blank {\r\n  font-size: 14px;\r\n}\r\n\r\n.ql-blank::before {\r\n  font-style: normal !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
